import { Box, BoxProps } from '@evaneos/b2b-ui';
import cx from 'classnames';

import s from './style.module.css';

type Props = {
    name: string;
    photoUrl?: string | null;
    className?: string;
} & Omit<BoxProps, 'title'>;

const getInitials = (string: string): string =>
    string
        .split(/(\s|-)/)
        .map((word) => word[0])
        .join(' ');

export const Avatar = ({ name, photoUrl, className, ...boxProps }: Props): JSX.Element => {
    const photo = photoUrl;
    return typeof photo === 'string' ? (
        <Box
            className={cx(s.avatar, className)}
            style={{ backgroundImage: `url(${photo})` }}
            title={name}
            {...boxProps}
        />
    ) : (
        <Box className={cx(s.avatar, s.letters, className)} title={name} {...boxProps}>
            {getInitials(name || '')}
        </Box>
    );
};
